<template>
  <select class="form-control" :class="{ 'required' : requireOwner }" id="owner" v-model="internalValue" :id="id">
    <option :value="null">State:</option>
    <option v-for="owner in owners" :key="owner.id" :value="owner.id">{{ owner.name }}</option>
  </select>
</template>

<script>
import {getOwners} from "../../api/api";

export default {

  props: {
    value: {
      default: null,
      required: true,
    },
    id: {
      type: String,
      required: false,
    },
    requireOwner: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      owners: [],
      internalValue: this.value,
    }
  },

  watch: {
    'internalValue': function (newValue) {
      // When the internal value changes, we $emit an event. Because this event is
      // named 'input', v-model will automatically update the parent value
      this.$emit('input', newValue);
    }
  },
  created: function () {
    getOwners().then((values) => {
      this.owners = values.data;
    })
  },
}

</script>